/* eslint-disable react-refresh/only-export-components */
import { lazy } from 'react'
import { Route } from 'react-router-dom'

const PrivacyPage = lazy(() => import('@/pages/legal/PrivacyPage').then((m) => ({ default: m.PrivacyPage })))
const TermsPage = lazy(() => import('@/pages/legal/TermsPage').then((m) => ({ default: m.TermsPage })))
const ForClubsPage = lazy(() => import('@/pages/marketing/ForClubs').then((m) => ({ default: m.ForClubsPage })))
const PricingPage = lazy(() => import('@/pages/marketing/Pricing').then((m) => ({ default: m.PricingPage })))
const SolutionsPage = lazy(() => import('@/pages/marketing/Solutions').then((m) => ({ default: m.SolutionsPage })))
const SolutionPage = lazy(() =>
  import('@/pages/marketing/solutions/SolutionPage').then((m) => ({ default: m.SolutionPage })),
)
const AboutPage = lazy(() => import('@/pages/marketing/About').then((m) => ({ default: m.AboutPage })))
// The signed-out unsubscribe landing. It belongs in THIS table and not behind
// `RequireAuth`: the person most likely to unsubscribe is the one least able to sign in,
// and the token in the query string is the entire credential (it can never mint a
// session). The path is the one `notifications/unsubscribe/link.mjs` builds every
// List-Unsubscribe header and footer link from — UNSUBSCRIBE_PATH = "/unsubscribe".
const UnsubscribePage = lazy(() =>
  import('@/pages/unsubscribe/Page').then((m) => ({ default: m.UnsubscribePage })),
)

export function marketingRoutes() {
  return (
    <>
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/for-clubs" element={<ForClubsPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/solutions" element={<SolutionsPage />} />
      {/* One data-driven route for every solution child page: the template
          looks the slug up in its content registry and renders the real
          404 page (noindex) on a miss — never a redirect to the hub. */}
      <Route path="/solutions/:slug" element={<SolutionPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/unsubscribe" element={<UnsubscribePage />} />
    </>
  )
}
